var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Checkbox } from '../Checkbox/index.js';
import { FormControlMeta } from './FormControlMeta.js';
export const FormControlCheckbox = forwardRef((props, ref) => {
    const { name, label, helperText, error, invalid, hidden } = props, rest = __rest(props, ["name", "label", "helperText", "error", "invalid", "hidden"]);
    return (React.createElement("div", { hidden: hidden },
        React.createElement(Checkbox, Object.assign({}, rest, { name: name, invalid: invalid, ref: ref }), label),
        React.createElement(FormControlMeta, Object.assign({}, { helperText, error, invalid }))));
});
//# sourceMappingURL=FormControlCheckbox.js.map